import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import Modal from 'react-modal';
import './ManageSrDzSzLevels.css';
import { API_KEY, BASE_URL, ensureArray, buildScopedApiUrl, getApiHeaders } from "./config";
import { useWorkspace } from "./workspace/WorkspaceContext";

function ManageSrDzSzLevels() {
  const { workspace, exchange, marketType } = useWorkspace();
  const [dataList, setDataList] = useState([]);
  const [coinDropdownOptions, setCoinDropdownOptions] = useState([]);
  const [availableCoinDropdownOptions, setAvailableCoinDropdownOptions] = useState([]);
  const [serverCoin, setServerCoin] = useState('');


  const [filteredList, setFilteredList] = useState([]);
  // NEW: centralize base
  const API_BASE = `/api/bot/ui/get`;
  const scopedUrl = useCallback((path, params = {}) => buildScopedApiUrl(`${API_BASE}${path}`, workspace, params), [workspace]);
  const DEFAULT_TYPE = 'ICT_MANUAL_TRADE_SR';
  // NEW: which params should the server query use?
  const [serverSel, setServerSel] = useState({ coin: false, type: false, timeFrame: false });
  const [serverType, setServerType] = useState('');
  const [serverTimeFrame, setServerTimeFrame] = useState('');

  const TYPE_OPTIONS = [
  'SR','POS_CLOSE_SR','REVERSAL_SIGNAL_SR','CRITICAL_SR','ICT_MANUAL_TRADE_SR', 'BULLISH_FVG_RANGE','BEARISH_FVG_RANGE',
  'ON_TOUCH_CLOSE_LONG_SR','ON_TOUCH_CLOSE_SHORT_SR',
  'RSI_BULLISH_DIV_SR','RSI_BEARISH_DIV_SR',
  'AO_BULLISH_DIV_SR','AO_BEARISH_DIV_SR',
  'SZ_SRSI_ENTRY_SR','DZ_SRSI_ENTRY_SR',
  'EMA_CROSS_TRENDONLY_ENTRY_SR',
  'SWING_HIGH_CLOSE_SR','SWING_LOW_CLOSE_SR','SWING_HIGH_WICK_SR','SWING_LOW_WICK_SR',
  'SUPPLY','DEMAND',
  'IGNORE_EMA_SIGNAL_BULL_RANGE_SR','IGNORE_EMA_SIGNAL_BEAR_RANGE_SR',
  'HIGHER_HIGH','HIGHER_LOW','LOWER_HIGH','LOWER_LOW',
  'ICT_SUPPLY','ICT_DEMAND','ICT_BULLISH_BREAKER','ICT_BEARISH_BREAKER',
  'EMA12EMA21_SWING_HIGH_CLOSE_SR','EMA12EMA21_SWING_LOW_CLOSE_SR',
  'EMA12EMA21_SWING_HIGH_WICK_SR','EMA12EMA21_SWING_LOW_WICK_SR','EMA50BAND_CHOPPY_RANGE','EMA50BAND_CHOPPY_SR'
];

  const SR_TYPES = [
    'SR', 'POS_CLOSE_SR', 'REVERSAL_SIGNAL_SR', 'CRITICAL_SR', 'ICT_MANUAL_TRADE_SR',
    'ON_TOUCH_CLOSE_LONG_SR', 'ON_TOUCH_CLOSE_SHORT_SR',
    'RSI_BULLISH_DIV_SR', 'RSI_BEARISH_DIV_SR',
    'AO_BULLISH_DIV_SR', 'AO_BEARISH_DIV_SR',
    'SZ_SRSI_ENTRY_SR', 'DZ_SRSI_ENTRY_SR',
    'EMA_CROSS_TRENDONLY_ENTRY_SR',
    'SWING_HIGH_CLOSE_SR', 'SWING_LOW_CLOSE_SR',
    'SWING_HIGH_WICK_SR', 'SWING_LOW_WICK_SR',
    'EMA12EMA21_SWING_HIGH_CLOSE_SR', 'EMA12EMA21_SWING_LOW_CLOSE_SR',
    'EMA12EMA21_SWING_HIGH_WICK_SR', 'EMA12EMA21_SWING_LOW_WICK_SR',
    'HIGHER_HIGH', 'HIGHER_LOW', 'LOWER_HIGH', 'LOWER_LOW','EMA50BAND_CHOPPY_SR'
  ];

  const ZONE_TYPES = [
    'SUPPLY', 'DEMAND',
    'ICT_SUPPLY', 'ICT_DEMAND',
    'ICT_BULLISH_BREAKER', 'ICT_BEARISH_BREAKER',
    'IGNORE_EMA_SIGNAL_BULL_RANGE_SR', 'IGNORE_EMA_SIGNAL_BEAR_RANGE_SR',
    'BULLISH_FVG_RANGE', 'BEARISH_FVG_RANGE','EMA50BAND_CHOPPY_RANGE'
  ];



  const [filters, setFilters] = useState({ coin: '', type: '', timeFrame: '', strictFlag: '', srStrictType: '' , crossModeForEntry: '', crossModeForExit: ''   
    ,   activeFlag: 'Y',status: '',levelTakenOutOn: '',comments: '',  
      derivedFromZoneId: '',
      breakerZoneId: '',
      wickLowOrHigh: '',
      attemptAllowed: '',
      attemptCompleted: '',
      msbStatus: '',
      swingLevelRetestedOn: '',
      swingLevelWickRetestedOn: '',
      createdDateFrom: '',
      createdDateTo: '',
      modifiedDateFrom: '',
      modifiedDateTo: ''
    });

      // Determine whether to show SR Level and Zone High/Low columns dynamically
  const showSRColumn = !ZONE_TYPES.includes(filters.type);
  const showZoneColumns = !SR_TYPES.includes(filters.type);



    // Fetch levels by a specific type (used on first load)
const fetchLevelsByType = useCallback(async (typeParam) => {
  try {
    const res = await fetch(scopedUrl('/getSrDzSzLevelsByType', { type: typeParam }),
                    {
                      headers: getApiHeaders()
                    });
    const data = await res.json();
    const normalizedLevels = ensureArray(data);
    if (!Array.isArray(data)) {
      console.warn('Unexpected SR/DZ/SZ level payload shape', data);
    }
    setDataList(normalizedLevels);

    // keep coin dropdown options in sync with what’s returned
    const coinNames = normalizedLevels.map(d => d.coin).filter(Boolean);
    const uniqueCoinsSet = new Set(coinNames);
    setAvailableCoinDropdownOptions(Array.from(uniqueCoinsSet));
  } catch (err) {
    setError(err.message);
  }
}, [scopedUrl]);

  useEffect(() => {
    // default load: show only ICT_MANUAL_TRADE_SR from server
    fetchLevelsByType('ICT_MANUAL_TRADE_SR');
    fetchCoinDropdown();
  }, [fetchLevelsByType, exchange, marketType]);


const [newRow, setNewRow] = useState({
  coin: '', type: '', srLevel: '', zoneHigh: '', zoneLow: '',
  timeFrame: '5', strictFlag: false, activeFlag: 'Y', status: '', levelTakenOutOn: '',
  srStrictType: '', comments: '', crossModeForEntry: '', crossModeForExit: '',
 derivedFromZoneId: '',
 breakerZoneId: '',
 wickLowOrHigh: '',
 attemptAllowed: '',
 attemptCompleted: '',
 msbStatus: '',
 swingLevelRetestedOn: '',
 swingLevelWickRetestedOn: ''
});

  const [editIndex, setEditIndex] = useState(null);
  const [editRowData, setEditRowData] = useState(null);
  const [error, setError] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState({ show: false, id: null });
  const [timeFrameOptions, setTimeFrameOptions] = useState(['5', '15', '30', '60', '240', '480', '720', '1440']);
    const [attemptOptions, setattemptOptions] = useState(['1', '2', '3', '4', '5']);

  const [showAutoLevelsModal, setShowAutoLevelsModal] = useState(false);
  const [modalSymbol, setModalSymbol] = useState('');
  const [modalPrice, setModalPrice] = useState('');
  const [spacingPercent, setSpacingPercent] = useState(3);
  const [autoLevels, setAutoLevels] = useState([]);
  const [batchColumn, setBatchColumn] = useState('');
  const [batchValue, setBatchValue]   = useState('');


  const uniqueCoins = [...new Set([filters.coin, ...dataList.map(d => d.coin).filter(Boolean)])];
  const uniqueTimeFrames = [...new Set([filters.timeFrame, ...dataList.map(d => d.timeFrame).filter(Boolean)])];

  const renderBatchValueInput = () => {
    if (!batchColumn) return null;
    switch (batchColumn) {
      case 'timeFrame':
        return (
          <select value={batchValue} onChange={e => setBatchValue(e.target.value)}>
            <option value="">Select</option>
            {timeFrameOptions.map(tf => <option key={tf} value={tf}>{tf}</option>)}
          </select>
        );
      case 'activeFlag':
        return (
          <select value={batchValue} onChange={e => setBatchValue(e.target.value)}>
            <option value="Y">Y</option>
            <option value="N">N</option>
          </select>
        );
      case 'strictFlag':
        return (
          <select value={batchValue} onChange={e => setBatchValue(e.target.value)}>
            <option value={true}>Y</option>
            <option value={false}>N</option>
          </select>
        );
      case 'srStrictType':
        return (
          <select value={batchValue} onChange={e => setBatchValue(e.target.value)}>
            <option value="">Select Type</option>
            <option value="ALL">ALL</option>
            <option value="BOTH_BUY_AND_SELL">BOTH_BUY_AND_SELL</option>
            <option value="BOTH_BUY_AND_SELL_WITH_CLOSE">BOTH_BUY_AND_SELL_WITH_CLOSE</option>
            <option value="BUY_ONLY">BUY_ONLY</option>
            <option value="BUY_ONLY_WITH_CLOSE">BUY_ONLY_WITH_CLOSE</option>
            <option value="SELL_ONLY">SELL_ONLY</option>
            <option value="SELL_ONLY_WITH_CLOSE">SELL_ONLY_WITH_CLOSE</option>
            <option value="CLOSE_ONLY">CLOSE_ONLY</option>
            <option value="CLOSE_BUY_ONLY">CLOSE_BUY_ONLY</option>
            <option value="CLOSE_SELL_ONLY">CLOSE_SELL_ONLY</option>
          </select>
        );


      case 'crossModeForEntry':
        return (
          <select value={batchValue} onChange={e => setBatchValue(e.target.value)}>
            <option value="">Select CrossMode</option>
            <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
            <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
            <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
          </select>
        );
      case 'crossModeForExit':
        return (
          <select value={batchValue} onChange={e => setBatchValue(e.target.value)}>
            <option value="">Select CrossMode</option>
            <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
            <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
            <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
          </select>
        );  
      case 'comments':
        return (
          <input
            type="text"
            placeholder="Enter comment"
            value={batchValue}
            onChange={e => setBatchValue(e.target.value)}
          />
        );
      default:
        return null;
    }
  };

  const handleBatchUpdate = async () => {
    if (!batchColumn || batchValue === '') return;

    // 1️⃣ Which rows are we touching?
    const toUpdateIds = new Set(filteredList.map(r => r.id));

    // 2️⃣ Optimistically update local state
    const updatedList = dataList.map(item =>
      toUpdateIds.has(item.id)
        ? { ...item, [batchColumn]: batchValue }
        : item
    );
    setDataList(updatedList);

    try {
      // 3️⃣ Bulk‐save each updated item
      await Promise.all(
        updatedList
          .filter(item => toUpdateIds.has(item.id))
          .map(item =>
            fetch(
              scopedUrl('/saveSrDzSzLevels'),
              {
                method: 'POST',
                headers: getApiHeaders({ 'Content-Type': 'application/json' }),
                body: JSON.stringify({ ...item, exchange, marketType }),
              }
            ).then(res => {
              if (!res.ok) throw new Error(`Save failed for ${item.id}`);
            })
          )
      );

      // 4️⃣ Re‐fetch from server to sync any side‐effects
      await refreshFromServer();
    } catch (err) {
      console.error(err);
      setError('Batch update failed—please try again');
      // rollback
      await refreshFromServer();
    }
  };


  const fetchCoinDropdown = async () => {
    try {
      const response = await fetch(scopedUrl('/getRecentActiveAlertSymbols'),
                      {
                        headers: getApiHeaders()
                      });
      const coins = await response.json();
      const normalizedCoins = ensureArray(coins);
      if (!Array.isArray(coins)) {
        console.warn('Unexpected SR/DZ/SZ coin dropdown payload shape', coins);
      }
      setCoinDropdownOptions(normalizedCoins);
    } catch (err) {
      console.error('Failed to fetch coin dropdown list:', err);
    }
  };


  async function refreshFromServer() {
  const { coin: useCoin, type: useType, timeFrame: useTF } = serverSel;
  const { type, timeFrame } = filters;

  let url = scopedUrl('/getSrDzSzLevelsByType', { type: DEFAULT_TYPE });

  if (useCoin && useType && useTF) {
    url = scopedUrl('/getSrDzSzLevelsByTimeFrameAndTypeAndCoin', { coin: serverCoin, type: serverType, timeFrame: serverTimeFrame });
  } else if (useCoin && useType) {
    url = scopedUrl('/getSrDzSzLevelsByCoinAndType', { coin: serverCoin, type: serverType });
  } else if (useType && useTF) {
   url = scopedUrl('/getSrDzSzLevelsByTypeAndTimeFrame', { type: serverType, timeFrame: serverTimeFrame });
  } else if (useTF && useCoin) {
   url = scopedUrl('/getSrDzSzLevelsByTimeFrameAndCoin', { timeFrame: serverTimeFrame, coin: serverCoin });
  } else if (useCoin) {
   url = scopedUrl('/getSrDzSzLevelsByCoin', { coin: serverCoin });
  } else if (useType) {
   url = scopedUrl('/getSrDzSzLevelsByType', { type: serverType });
  } else if (useTF) {
   url = scopedUrl('/getSrDzSzLevelsByTimeFrame', { timeFrame: serverTimeFrame });
  } else {
   url = scopedUrl('/getSrDzSzLevelsByType', { type: DEFAULT_TYPE });
  }

  try {
    const res = await fetch(url, {
        headers: getApiHeaders()
      });
    if (!res.ok) throw new Error(`Server fetch failed (${res.status})`);
    const data = await res.json();
    const normalizedLevels = ensureArray(data);
    if (!Array.isArray(data)) {
      console.warn('Unexpected SR/DZ/SZ server search payload shape', data);
    }
    setDataList(normalizedLevels);

    const coinNames = normalizedLevels.map(d => d.coin).filter(Boolean);
    setAvailableCoinDropdownOptions(Array.from(new Set(coinNames)));
  } catch (err) {
    setError(err.message);
  }
}

async function fetchBySelection() {
  const { coin: useCoin, type: useType, timeFrame: useTF } = serverSel;
  const { type, timeFrame } = filters;

  if (!useCoin && !useType && !useTF) {
    alert('Tick at least one of Coin / Type / Time Frame to fetch.');
    return;
  }
  if (useCoin && !serverCoin) { alert('Pick a Coin in the server dropdown.'); return; }
  if (useType && !serverType) { alert('Pick a Type in the server dropdown.'); return; }
  if (useTF && !serverTimeFrame) { alert('Pick a Time Frame in the server dropdown.'); return; }

  await refreshFromServer();
}

function resetServerFetch() {
  setServerSel({ coin: false, type: false, timeFrame: false });
  setServerCoin('');
  setServerType('');
  setServerTimeFrame('');
  setFilters(f => ({ ...f, type: '', coin: '', timeFrame: '' }));
  fetchLevelsByType(DEFAULT_TYPE);
}


      
  const applyFilters = useCallback(() => {
    let filtered = dataList.filter(item => (
      (filters.coin === '' || item.coin.toLowerCase().includes(filters.coin.toLowerCase())) &&
      (filters.type === '' || item.type.toLowerCase().includes(filters.type.toLowerCase())) &&
      (filters.timeFrame === '' || item.timeFrame === parseInt(filters.timeFrame)) &&
      (filters.strictFlag  === '' || item.strictFlag  === (filters.strictFlag === 'true')) &&
      (filters.srStrictType === '' || item.srStrictType === filters.srStrictType) &&
      (filters.crossModeForEntry === '' || item.crossModeForEntry === filters.crossModeForEntry) &&
      (filters.crossModeForExit === '' || item.crossModeForExit === filters.crossModeForExit) &&
      (filters.activeFlag === '' || item.activeFlag.toLowerCase().includes(filters.activeFlag.toLowerCase())) && 
      (filters.status === '' ||
      (filters.status === '__EMPTY__'
        ? item.status === null || item.status === ''
          : (item.status ?? '').toLowerCase().includes(filters.status.toLowerCase()))) &&

      (filters.status === '' ||
      (filters.status === '__EMPTY__'
        ? item.status === null || item.status === ''
          : (item.status ?? '').toLowerCase().includes(filters.status.toLowerCase()))) &&    

      (filters.status === '' ||
      (filters.status === '__EMPTY__'
        ? item.status === null || item.status === ''
          : (item.status ?? '').toLowerCase().includes(filters.status.toLowerCase()))) &&
          
             (filters.status === '' ||
      (filters.status === '__EMPTY__'
        ? item.status === null || item.status === ''
          : (item.status ?? '').toLowerCase().includes(filters.status.toLowerCase()))) &&
          
          
      (filters.levelTakenOutOn === '' ||
      (filters.levelTakenOutOn === '__EMPTY__'
        ? item.levelTakenOutOn === null || item.levelTakenOutOn === ''
          : (item.levelTakenOutOn ?? '').toLowerCase().includes(filters.levelTakenOutOn.toLowerCase()))) &&                 
      (filters.comments === '' ||
        (item.comments || '')
          .toLowerCase()
          .includes(filters.comments.toLowerCase())) && 
      (filters.attemptAllowed === '' || item.attemptAllowed === parseInt(filters.attemptAllowed)) &&
      (filters.attemptCompleted === '' || item.attemptCompleted === parseInt(filters.attemptCompleted)) &&
      (filters.derivedFromZoneId === '' || String(item.derivedFromZoneId || '').includes(filters.derivedFromZoneId)) &&
      (filters.breakerZoneId === '' || String(item.breakerZoneId || '').includes(filters.breakerZoneId)) &&
      (filters.wickLowOrHigh === '' ||
         parseFloat(item.wickLowOrHigh) === parseFloat(filters.wickLowOrHigh)) &&
      (filters.msbStatus === '' || item.msbStatus === filters.msbStatus) &&
      (filters.swingLevelRetestedOn === '' || (item.swingLevelRetestedOn || '').toLowerCase().includes(filters.swingLevelRetestedOn.toLowerCase())) &&
      (filters.swingLevelWickRetestedOn === '' || (item.swingLevelWickRetestedOn || '').toLowerCase().includes(filters.swingLevelWickRetestedOn.toLowerCase())) &&

      (filters.createdDateFrom === '' || (item.createdDate && new Date(item.createdDate) >= new Date(filters.createdDateFrom))) &&
      (filters.createdDateTo === ''   || (item.createdDate && new Date(item.createdDate) <= new Date(filters.createdDateTo))) &&
      (filters.modifiedDateFrom === '' || (item.modifiedDate && new Date(item.modifiedDate) >= new Date(filters.modifiedDateFrom))) &&
      (filters.modifiedDateTo === ''   || (item.modifiedDate && new Date(item.modifiedDate) <= new Date(filters.modifiedDateTo))) 
    ));
    setFilteredList(filtered);
  }, [dataList, filters]);

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  const handleFilterChange = (e, field) => {
    setFilters({ ...filters, [field]: e.target.value });
  };

  const handleAdd = async () => {
    if (!newRow.coin || !newRow.type) {
      alert("Coin and Type are required");
      return;
    }

    if (SR_TYPES.includes(newRow.type) && !newRow.srLevel) {
      alert("SR Level is required for SR type");
      return;
    }

    if (ZONE_TYPES.includes(newRow.type) && (!newRow.zoneHigh || !newRow.zoneLow)) {
      alert("Zone High and Zone Low are required for Zone or Range Based type");
      return;
    }
  
    try {
      await fetch(scopedUrl('/saveSrDzSzLevels'), {
        method: 'POST',
        headers: getApiHeaders({ 'Content-Type': 'application/json' }),
              body: JSON.stringify({
                 ...newRow,
                  exchange,
                  marketType,
                  srStrictType: newRow.srStrictType,
                  comments:   newRow.comments,
                  crossModeForEntry: newRow.crossModeForEntry, 
                  crossModeForExit: newRow.crossModeForExit,
                  derivedFromZoneId: newRow.derivedFromZoneId,
                  breakerZoneId: newRow.breakerZoneId,
                  wickLowOrHigh: newRow.wickLowOrHigh,
                  attemptAllowed: newRow.attemptAllowed,
                  attemptCompleted: newRow.attemptCompleted,
                  msbStatus: newRow.msbStatus,
                  swingLevelRetestedOn: newRow.swingLevelRetestedOn,
                  swingLevelWickRetestedOn: newRow.swingLevelWickRetestedOn
                })
      });
          setNewRow({
              coin: '', type: '', srLevel: '', zoneHigh: '', zoneLow: '',
              timeFrame: '', strictFlag: false, activeFlag: 'Y', status: '',levelTakenOutOn: '',
              srStrictType: '', comments: '',  crossModeForEntry: '', crossModeForExit: '',
              derivedFromZoneId: '',
              breakerZoneId: '',
              wickLowOrHigh: '',
              attemptAllowed: '',
              attemptCompleted: '',
              msbStatus: '',
              swingLevelRetestedOn: '',
              swingLevelWickRetestedOn: ''   
            });
      refreshFromServer();
    } catch (err) {
      setError(err.message);
    }
  };
  

  const handleEdit = (index) => {
        const row = filteredList[index];
        setEditIndex(index);
        setEditRowData({
          // bring in every field + make sure srStrictType/comments are always strings
          ...row,
          srStrictType: row.srStrictType || '',
          comments:   row.comments   || '',
          crossModeForEntry: row.crossModeForEntry || '', 
          crossModeForExit: row.crossModeForExit || ''   
        });
  };

  const handleDeleteAllFiltered = async () => {
    if (filteredList.length === 0) {
      alert("No rows to delete based on current filters");
      return;
    }
  
    const confirmed = window.confirm(`Are you sure you want to delete all ${filteredList.length} level(s) currently shown in the table?`);
    if (!confirmed) return;
  
    try {
      const ids = filteredList.map(row => row.id);
      await fetch(scopedUrl('/deleteSrDzSzLevelsByIds'), {
        method: 'DELETE', // ✅ FIXED METHOD
        headers: { 'Content-Type': 'application/json',
                  "X-SIGNALFLY-KEY": API_KEY
                },
        body: JSON.stringify(ids)
      });
      refreshFromServer();
    } catch (err) {
      alert("Failed to delete levels. Please try again.");
    }
  };
  
  
  const handleSave = async () => {
    try {
      await fetch(scopedUrl('/saveSrDzSzLevels'), {
          method: 'POST',
          headers: getApiHeaders({ 'Content-Type': 'application/json' }),
                body: JSON.stringify({
                    ...editRowData,
                    exchange,
                    marketType,
                    srStrictType: editRowData.srStrictType,
                  comments:   editRowData.comments,
                  crossModeForEntry: editRowData.crossModeForEntry, 
                  crossModeForExit: editRowData.crossModeForExit,
                  derivedFromZoneId: editRowData.derivedFromZoneId,
                  breakerZoneId: editRowData.breakerZoneId,
                  wickLowOrHigh: editRowData.wickLowOrHigh,
                  attemptAllowed: editRowData.attemptAllowed,
                  attemptCompleted: editRowData.attemptCompleted,
                  msbStatus: editRowData.msbStatus,
                  swingLevelRetestedOn: editRowData.swingLevelRetestedOn,
                  swingLevelWickRetestedOn: editRowData.swingLevelWickRetestedOn  
                })
      });
      setEditIndex(null);
      refreshFromServer();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
        await fetch(scopedUrl('/deleteSrDzSzLevelsAdvancedById', { id }), {
          method: 'DELETE',
          headers: getApiHeaders()
        });
      setConfirmDelete({ show: false, id: null });
      refreshFromServer();
    } catch (err) {
      setError(err.message);
    }
  };

const handleClearFilters = () => {
  setFilters({
    coin: '',
    type: '',
    timeFrame: '',
    strictFlag: '',
    srStrictType: '',
    crossModeForEntry: '',
    crossModeForExit: '',
    activeFlag: '',
    status: '',
    levelTakenOutOn: '',
    comments: '',
    derivedFromZoneId: '',
    breakerZoneId: '',
    wickLowOrHigh: '',
    attemptAllowed: '',
    attemptCompleted: '',
    msbStatus: '',        
    swingLevelRetestedOn: '',
    swingLevelWickRetestedOn: '',
    createdDateFrom: '',
    createdDateTo: '',
    modifiedDateFrom: '',
    modifiedDateTo: ''
  });
};



  // Determine SR / Zone types dynamically
  const isNewSR = SR_TYPES.includes(newRow.type);
  const isEditSR = SR_TYPES.includes(editRowData?.type);

  const isNewZone = ZONE_TYPES.includes(newRow.type);
  const isEditZone = ZONE_TYPES.includes(editRowData?.type);


  const openAutoLevelModal = async () => {
    if (newRow.coin) {
      try {
        const response = await fetch(`${BASE_URL}/api/bot/get/getMarkPriceBySymbol?symbol=${newRow.coin}`,
                        {
                          headers: {
                            "X-SIGNALFLY-KEY": API_KEY
                          }
                        });
        const data = await response.json();
        const marketPrice = parseFloat(data.markPrice);
        setModalSymbol(newRow.coin);
        setModalPrice(marketPrice);
        generateAutoLevels(marketPrice, spacingPercent);
        setShowAutoLevelsModal(true);
      } catch (err) {
        alert('Failed to fetch market price');
      }
    } else {
      alert("Please enter Coin to fetch current price");
    }
  };

  const generateAutoLevels = (price, percent) => {
    const spacing = price * (percent / 100);

    const levels = [    
      price + spacing * 3,
      price + spacing * 2,
      price + spacing,
      price,
      price - spacing,
      price - spacing * 2,
      price - spacing * 3,
    ];

    setAutoLevels(levels.map(lvl => parseFloat(lvl.toFixed(4))));
  };

  const saveAutoLevels = async () => {
    try {
      const rows = autoLevels.map((lvl) => ({
        coin: modalSymbol,
        type: 'SR',
        srLevel: lvl,
        zoneHigh: '',
        zoneLow: '',
        timeFrame: newRow.timeFrame,
        strictFlag: false,
        activeFlag: 'Y',
        status: '',
        levelTakenOutOn: ''
      }));

      await fetch(scopedUrl('/saveBulkSrDzSzLevels'), {
          method: 'POST',
          headers: getApiHeaders({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(rows.map((row) => ({ ...row, exchange, marketType })))
        });

      setShowAutoLevelsModal(false);
      refreshFromServer();
    } catch (err) {
      alert('Failed to save auto levels');
    }
  };
  const AutoSRLevelModal = () => {
    const highlightLevel = (level, isSupport, isResistance) => {
      if (isSupport) return "highlight-support"; // Apply this class for support
      if (isResistance) return "highlight-resistance"; // Apply this class for resistance
      return "";
    };


    
  
    return (
      <Modal
        isOpen={showAutoLevelsModal}
        onRequestClose={() => setShowAutoLevelsModal(false)}
        contentLabel="Auto Generate SR Levels"
        className="styled-modal-content"
        overlayClassName="styled-modal-overlay"
      >
        <button className="modal-close-button" onClick={() => setShowAutoLevelsModal(false)}>&times;</button>
        <h2 className="modal-title">Auto Generate SR Levels</h2>
        <div className="modal-field">
          <label><strong>Symbol:</strong></label>
          <span>{modalSymbol}</span>
        </div>
        <div className="modal-field">
          <label><strong>Market Price:</strong></label>
          <span>{modalPrice}</span>
        </div>
        <div className="modal-field">
          <label>Spacing (%):</label>
          <input
            type="number"
            value={spacingPercent}
            onChange={(e) => {
              const val = parseFloat(e.target.value);
              setSpacingPercent(val);
              generateAutoLevels(modalPrice, val);
            }}
          />
        </div>
  
        <div className="levels-list">
          {autoLevels.map((lvl, idx) => {
            const prev = autoLevels[idx - 1];
            const diff = prev ? (lvl - prev).toFixed(4) : null;
            const pct = prev ? (((lvl - prev) / prev) * 100).toFixed(2) + '%' : null;
  
            const isSupport = lvl < modalPrice && (autoLevels[idx + 1] > modalPrice || !autoLevels[idx + 1]);
            const isResistance = lvl > modalPrice && (autoLevels[idx - 1] < modalPrice || !autoLevels[idx - 1]);
  
            return (
              <div key={idx} className={`level-item ${highlightLevel(lvl, isSupport, isResistance)}`}>
                <input
                  type="number"
                  value={lvl}
                  onChange={(e) => {
                    const updated = [...autoLevels];
                    updated[idx] = parseFloat(e.target.value);
                    setAutoLevels(updated);
                  }}
                />
                <button className="remove-level" onClick={() => setAutoLevels(autoLevels.filter((_, i) => i !== idx))}>&times;</button>
                {diff && <div className="diff-label">Δ {diff} ({pct})</div>}
              </div>
            );
          })}
        </div>
  
        <div style={{ marginTop: '10px' }}>
          <button className="btn add" onClick={() => setAutoLevels([...autoLevels, parseFloat((modalPrice).toFixed(4))])}>+ Add Level</button>
        </div>
  
        <div className="modal-button-container">
          <button className="btn save" onClick={saveAutoLevels}>Save Levels</button>
          <button className="btn cancel" onClick={() => setShowAutoLevelsModal(false)}>Cancel</button>
        </div>
      </Modal>
    );
  };

  const tableWrapperRef = useRef(null);

  // just below your useRef for the table wrapper
const newRowRef     = useRef(null);
const coinSelectRef = useRef(null);

const handleAddSRClick = () => {
  if (newRowRef.current) {
    // scroll the new-row into view
    newRowRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
  }
  // small timeout so that the browser has laid out the new-row
  setTimeout(() => {
    if (coinSelectRef.current) {
      coinSelectRef.current.focus();
      // open the native dropdown if the browser supports it:
      // coinSelectRef.current.size = coinSelectRef.current.options.length;
    }
  }, 300);
}
  
// ── Sorting state ───────────────────────────────────
const [sortConfig, setSortConfig] = useState({ key: 'createdDate', direction: 'descending' });

const requestSort = (key) => {
  let direction = 'ascending';
  if (sortConfig.key === key && sortConfig.direction === 'ascending') {
    direction = 'descending';
  }
  setSortConfig({ key, direction });

  // scroll the table wrapper back to top (or into view)
  if (tableWrapperRef.current) {
    // if you want to scroll the container itself:
    tableWrapperRef.current.scrollTop = 0;
    // OR, if you want the page to jump so the table is at the top of viewport:
    // tableWrapperRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

const sortedList = useMemo(() => {
  const sortableItems = [...filteredList];
  if (sortConfig.key) {
    sortableItems.sort((a, b) => {
      let aVal, bVal;
      const direction = sortConfig.direction === 'ascending' ? 1 : -1;

      if (['createdDate', 'modifiedDate'].includes(sortConfig.key)) {
        const rawA = a[sortConfig.key];
        const rawB = b[sortConfig.key];
        aVal = rawA ? new Date(rawA).getTime() : (direction === 1 ? Infinity : -Infinity);
        bVal = rawB ? new Date(rawB).getTime() : (direction === 1 ? Infinity : -Infinity);
      } else if (['srLevel', 'zoneHigh', 'zoneLow', 'timeFrame','wickLowOrHigh'].includes(sortConfig.key)) {
        const rawA = a[sortConfig.key];
        const rawB = b[sortConfig.key];
        aVal = (rawA != null && rawA !== '') ? parseFloat(rawA) : (direction === 1 ? Infinity : -Infinity);
        bVal = (rawB != null && rawB !== '') ? parseFloat(rawB) : (direction === 1 ? Infinity : -Infinity);
      } else {
        aVal = String(a[sortConfig.key] || '').toLowerCase();
        bVal = String(b[sortConfig.key] || '').toLowerCase();
      }

      if (aVal < bVal) return -1 * direction;
      if (aVal > bVal) return 1 * direction;
      return 0;
    });
  }
  return sortableItems;
}, [filteredList, sortConfig]);

const colCount = useMemo(() => {
  // Base columns: #, Coin, Type
  let count = 3;

  // Conditional columns
  if (showSRColumn) count += 1;     // SR Level
  if (showZoneColumns) count += 2;  // Zone High, Zone Low

  // Always-visible columns after that:
  // Strict, Strict Type, CrossMode Entry, CrossMode Exit, Comments,
  // Time Frame, Attempt, Active, Status, levelTakenOutOn,
  // Created, Modified, Actions  => 13 columns
  count += 22;

  return count;
}, [showSRColumn, showZoneColumns]);

  return (
    <div className="sr-dz-sz-page">
      <h2 className="page-title">Manage SR/Demand/Supply Levels</h2>
      {error && <p className="error-message">{error}</p>}

      {/* NEW: Server-side fetch by selected params (uses values from the filter row) */}
      <div className="server-fetch-panel">
        <div className="server-fetch-group">
          <label>
            <input
              type="checkbox"
              checked={serverSel.coin}
              onChange={e => setServerSel(s => ({ ...s, coin: e.target.checked }))}
            />
            Coin
          </label>
          <select
            className="server-coin-select"
            value={serverCoin}
            onChange={e => setServerCoin(e.target.value)}
            disabled={!serverSel.coin}
          >
            <option value="">Select coin…</option>
            {coinDropdownOptions.map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
          </select>
        </div>

        <div className="server-fetch-group">
          <label>
            <input
              type="checkbox"
              checked={serverSel.type}
              onChange={e => setServerSel(s => ({ ...s, type: e.target.checked }))}
            />
            Type
          </label>
             <select
                className="server-type-select"
                value={serverType}
                onChange={e => setServerType(e.target.value)}
                disabled={!serverSel.type}
              >
                <option value="">Select type…</option>
                {TYPE_OPTIONS.map(t => (
                  <option key={t} value={t}>{t}</option>
                ))}
              </select>
        </div>

        <div className="server-fetch-group">
          <label>
            <input
              type="checkbox"
              checked={serverSel.timeFrame}
              onChange={e => setServerSel(s => ({ ...s, timeFrame: e.target.checked }))}
            />
            Time Frame
          </label>
             <select
                className="server-tf-select"
                value={serverTimeFrame}
                onChange={e => setServerTimeFrame(e.target.value)}
                disabled={!serverSel.timeFrame}
              >
                <option value="">Select TF…</option>
                {timeFrameOptions.map(tf => (
                  <option key={tf} value={tf}>{tf}</option>
                ))}
              </select>
        </div>

        <button className="btn apply" onClick={fetchBySelection}>
          Fetch
        </button>
        <button className="btn clear-filters professional-clear" onClick={resetServerFetch}>
          Reset to Default
        </button>

      </div>

    
      <div className="filter-actions">    
      <button className="btn add-sr" onClick={handleAddSRClick}>
        Add SR
      </button>
      <button className="btn delete" onClick={handleDeleteAllFiltered}>Delete All Filtered</button>
        <button className="btn clear-filters professional-clear"  onClick={handleClearFilters}>Clear All Filters</button>
      </div>

      <div className="batch-update-panel" style={{ display: 'flex', gap: '8px', marginBottom: '16px' }}>
        <label>
          Update Column:
          <select value={batchColumn} onChange={e => {
            setBatchColumn(e.target.value);
            setBatchValue('');               // reset value when column changes
          }}>
            <option value="">Select Column</option>
            <option value="timeFrame">Time Frame</option>
            <option value="activeFlag">Active</option>
            <option value="strictFlag">Strict Flag</option>
            <option value="srStrictType">Strict Type</option>
            <option value="comments">Comments</option>
            <option value="crossModeForEntry">crossModeForEntry</option>
            <option value="crossModeForExit">crossModeForExit</option>  
          </select>
        </label>

        {renderBatchValueInput()}

        <button
          className="btn apply"
          onClick={handleBatchUpdate}
          disabled={!batchColumn || batchValue === ''}
        >
          Apply to All Filtered
        </button>
      </div>


      <div className="modal-table-wrapper" ref={tableWrapperRef}>
        <table className="sr-table">
          <thead>
          <tr>
            <th className="sequence-col">#</th> 
            <th onClick={() => requestSort('coin')} style={{ cursor: 'pointer' }}>
              Coin {sortConfig.key === 'coin' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th onClick={() => requestSort('type')} style={{ cursor: 'pointer' }}>
              Type {sortConfig.key === 'type' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            {showSRColumn && (
              <th onClick={() => requestSort('srLevel')} style={{ cursor: 'pointer' }}>
                SR Level {sortConfig.key === 'srLevel' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
              </th>
            )}
            {showZoneColumns && (
              <>
                <th onClick={() => requestSort('zoneHigh')} style={{ cursor: 'pointer' }}>
                  Zone High {sortConfig.key === 'zoneHigh' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                </th>
                <th onClick={() => requestSort('zoneLow')} style={{ cursor: 'pointer' }}>
                  Zone Low {sortConfig.key === 'zoneLow' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
                </th>
              </>
            )}
            <th onClick={() => requestSort('strictFlag')} style={{ cursor: 'pointer' }}>
              Strict {sortConfig.key === 'strictFlag' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th onClick={() => requestSort('srStrictType')} style={{ cursor: 'pointer' }}>
              Strict Type {sortConfig.key === 'srStrictType' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th onClick={() => requestSort('crossModeForEntry')} style={{ cursor: 'pointer' }}>
              CrossMode for Entry {sortConfig.key === 'crossModeForEntry' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th onClick={() => requestSort('crossModeForExit')} style={{ cursor: 'pointer' }}>
              CrossMode for Exit {sortConfig.key === 'crossModeForExit' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>

             <th
                onClick={() => requestSort('comments')}
                style={{ cursor: 'pointer' }}
              >
                Comments {sortConfig.key === 'comments'
                  ? (sortConfig.direction === 'ascending' ? ' ↑' : ' ↓')
                  : ''}
              </th>
            <th onClick={() => requestSort('timeFrame')} style={{ cursor: 'pointer' }}>
              Time Frame {sortConfig.key === 'timeFrame' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th onClick={() => requestSort('activeFlag')} style={{ cursor: 'pointer' }}>
              Active {sortConfig.key === 'activeFlag' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th onClick={() => requestSort('status')} style={{ cursor: 'pointer' }}>
              Status {sortConfig.key === 'status' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>     
            <th onClick={() => requestSort('levelTakenOutOn')} style={{ cursor: 'pointer' }}>
              levelTakenOutOn {sortConfig.key === 'levelTakenOutOn' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>    

            <th onClick={() => requestSort('msbStatus')} style={{ cursor: 'pointer' }}>MSB Status</th>
            <th onClick={() => requestSort('swingLevelRetestedOn')} style={{ cursor: 'pointer' }}>Swing Retested On</th>
            <th onClick={() => requestSort('swingLevelWickRetestedOn')} style={{ cursor: 'pointer' }}>Wick Retested On</th>  
            <th onClick={() => requestSort('wickLowOrHigh')} style={{ cursor: 'pointer' }}>WickLow/High</th>

            <th onClick={() => requestSort('attemptAllowed')} style={{ cursor: 'pointer' }}>AttemptAllowed</th>
            <th onClick={() => requestSort('attemptCompleted')} style={{ cursor: 'pointer' }}>AttemptCompleted</th>
            <th onClick={() => requestSort('derivedFromZoneId')} style={{ cursor: 'pointer' }}>DerivedFromZoneId</th>
            <th onClick={() => requestSort('breakerZoneId')} style={{ cursor: 'pointer' }}>BreakerZoneId</th>

            <th onClick={() => requestSort('createdDate')} style={{ cursor: 'pointer' }}>
              Created {sortConfig.key === 'createdDate' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>
            <th onClick={() => requestSort('modifiedDate')} style={{ cursor: 'pointer' }}>
              Modified {sortConfig.key === 'modifiedDate' ? (sortConfig.direction === 'ascending' ? '↑' : '↓') : ''}
            </th>

            <th>Actions</th>
          </tr>
            <tr className="filter-row">
            <td className="sequence-col"></td>
            <td>
                <select value={filters.coin} onChange={(e) => handleFilterChange(e, 'coin')}>
                  <option value="">All</option>
                  {availableCoinDropdownOptions.map((coin, index) => (
                    <option key={index} value={coin}>{coin}</option>
                  ))}
                </select>
              </td>

              <td>
              <select value={filters.type} onChange={(e) => handleFilterChange(e, 'type')}>
                <option value="">All</option>
                {TYPE_OPTIONS.map((type) => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
              </td>
              {showSRColumn && <td></td>}
              {showZoneColumns && (
                <>
                  <td></td>
                  <td></td>
                </>
              )}
             <td>
              <select
                value={filters.strictFlag}
                onChange={e => handleFilterChange(e, 'strictFlag')}
              >
                <option value="">Strict Flag</option>
                <option value="true">Y</option>
                <option value="false">N</option>
              </select>
            </td>

            <td>
              <select
                value={filters.srStrictType}
                onChange={e => handleFilterChange(e, 'srStrictType')}
              >
                <option value="">All Strict Types</option>
                <option value="ALL">ALL</option>
                <option value="BOTH_BUY_AND_SELL">BOTH_BUY_AND_SELL</option>
                <option value="BOTH_BUY_AND_SELL_WITH_CLOSE">BOTH_BUY_AND_SELL_WITH_CLOSE</option>
                <option value="BUY_ONLY">BUY_ONLY</option>
                <option value="BUY_ONLY_WITH_CLOSE">BUY_ONLY_WITH_CLOSE</option>
                <option value="SELL_ONLY">SELL_ONLY</option>
                <option value="SELL_ONLY_WITH_CLOSE">SELL_ONLY_WITH_CLOSE</option>
                <option value="CLOSE_ONLY">CLOSE_ONLY</option>
                <option value="CLOSE_BUY_ONLY">CLOSE_BUY_ONLY</option>
                <option value="CLOSE_SELL_ONLY">CLOSE_SELL_ONLY</option>
              </select>
            </td>

            <td>
              <select
                value={filters.crossModeForEntry}
                onChange={e => handleFilterChange(e, 'crossModeForEntry')}
              >
              <option value="">All</option>
              <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
              <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
              <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
              </select>
            </td>
            <td>
              <select
                value={filters.crossModeForExit}
                onChange={e => handleFilterChange(e, 'crossModeForExit')}
              >
              <option value="">All</option>
              <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
              <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
              <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
              </select>
            </td>

            <td>
                <input
                  type="text"
                value={filters.comments}
                onChange={e => handleFilterChange(e, 'comments')}
                placeholder="Filter comments…"
                  style={{ width: '100%' }}
                />
              </td>
              <td> 
                <select
                  className="new-row-select"
                  value={filters.timeFrame}
                  onChange={(e) => setFilters({ ...filters, timeFrame: e.target.value })}
                >
                  <option value="">All Time Frames</option>
                  {timeFrameOptions.map((tf, index) => (
                    <option key={index} value={tf}>{tf}</option>
                  ))}
                </select></td>

              <td>
                <select value={filters.activeFlag} onChange={(e) => handleFilterChange(e, 'activeFlag')}>
                  <option value="">All</option>
                  <option value="Y">Y</option>
                  <option value="N">N</option>
                </select>
              </td>
               <td>
                <select value={filters.status} onChange={(e) => handleFilterChange(e, 'status')}>
                  <option value="">All</option>
                  <option value="TAKEN_OUT">TAKEN_OUT</option>
                  <option value="LIQ_SWEPT">LIQ_SWEPT</option>
                  <option value="FVG_TAGGED">FVG_TAGGED</option>
                  <option value="FVG_SWEPT">FVG_SWEPT</option>
                  <option value="__EMPTY__">[Empty / Null]</option>
                </select>
              </td>   
              <td>
                <input
                  type="text"
                value={filters.levelTakenOutOn}
                onChange={e => handleFilterChange(e, 'levelTakenOutOn')}
                placeholder="Filter levelTakenOutOn…"
                  style={{ width: '100%' }}
                />
              </td>          


              <td>
                <select
                  value={filters.msbStatus}
                  onChange={e => handleFilterChange(e, 'msbStatus')}
                >
                  <option value="">All</option>
                  <option value="MSB_BULLISH">MSB_BULLISH</option>
                  <option value="MSB_BEARISH">MSB_BEARISH</option>
                </select>
              </td>


              <td>
                <input
                  type="text"
                  value={filters.swingLevelRetestedOn}
                  onChange={e => handleFilterChange(e, 'swingLevelRetestedOn')}
                  placeholder="Swing Retested On"
                />
              </td>

              <td>
                <input
                  type="text"
                  value={filters.swingLevelWickRetestedOn}
                  onChange={e => handleFilterChange(e, 'swingLevelWickRetestedOn')}
                  placeholder="Wick Retested On"
                />
              </td>

              <td>
                <input
                  type="number"
                   step="0.0001"
                  value={filters.wickLowOrHigh}
                  onChange={e => handleFilterChange({ target: { value: e.target.value.toString() } }, 'wickLowOrHigh')}
                  placeholder="Wick Low/High"
                  style={{ width: '100%' }}
                />
              </td>

              <td>
              <select
                value={filters.attemptAllowed}
                onChange={e => handleFilterChange(e, 'attemptAllowed')}
              >
                <option value="">All</option>
                {attemptOptions.map((opt, idx) => (
                  <option key={idx} value={opt}>{opt}</option>
                ))}
              </select>
              </td>

              <td>
              <select
                value={filters.attemptCompleted}
                onChange={e => handleFilterChange(e, 'attemptCompleted')}
              >
                <option value="">All</option>
                {attemptOptions.map((opt, idx) => (
                  <option key={idx} value={opt}>{opt}</option>
                ))}
              </select>
              </td>

              <td>
                <input
                  type="text"
                  value={filters.derivedFromZoneId}
                  onChange={e => handleFilterChange(e, 'derivedFromZoneId')}
                  placeholder="DerivedFromZoneId"
                />
              </td>

              <td>
                <input
                  type="text"
                  value={filters.breakerZoneId}
                  onChange={e => handleFilterChange(e, 'breakerZoneId')}
                  placeholder="BreakerZoneId"
                />
              </td>

              <td>
                <div className="date-filter-wrapper">
                  <input
                    type="date"
                    value={filters.createdDateFrom}
                    onChange={e => handleFilterChange(e, 'createdDateFrom')}
                    placeholder="From"
                  />
                  <input
                    type="date"
                    value={filters.createdDateTo}
                    onChange={e => handleFilterChange(e, 'createdDateTo')}
                    placeholder="To"
                  />
                </div>
              </td>

              <td>
                <div className="date-filter-wrapper">
                  <input
                    type="date"
                    value={filters.modifiedDateFrom}
                    onChange={e => handleFilterChange(e, 'modifiedDateFrom')}
                    placeholder="From"
                  />
                  <input
                    type="date"
                    value={filters.modifiedDateTo}
                    onChange={e => handleFilterChange(e, 'modifiedDateTo')}
                    placeholder="To"
                  />
                </div>
              </td>

            <td></td>
            </tr>
          </thead>
          <tbody>
             {sortedList.length === 0 && (
              <tr className="empty-row">
                <td colSpan={colCount} style={{ textAlign: 'center', padding: '12px', color: '#777' }}>
                  No Records
                </td>
              </tr>
            )}
          {sortedList.map((row, index) => (
              <tr key={row.id}>
                <td className="sequence-col">{index + 1}</td>
                <td>{editIndex === index ? <input value={editRowData.coin} onChange={(e) => setEditRowData({ ...editRowData, coin: e.target.value })} /> : row.coin}</td>
                <td>{editIndex === index ? <select value={editRowData.type} onChange={(e) => setEditRowData({ ...editRowData, type: e.target.value })}>
                    <option value="">Select</option>
                      {TYPE_OPTIONS.map(t => (
                        <option key={t} value={t}>{t}</option>
                      ))}                                                 
                  </select> : row.type}</td>
                {showSRColumn && (
                  <td>{editIndex === index ? <input value={editRowData.srLevel || ''} onChange={e => setEditRowData({ ...editRowData, srLevel: e.target.value })} disabled={!isEditSR} /> : row.srLevel}</td>
                )}
                {showZoneColumns && (
                  <>
                    <td>{editIndex === index ? <input value={editRowData.zoneHigh || ''} onChange={e => setEditRowData({ ...editRowData, zoneHigh: e.target.value })} disabled={!isEditZone} /> : row.zoneHigh}</td>
                    <td>{editIndex === index ? <input value={editRowData.zoneLow || ''} onChange={e => setEditRowData({ ...editRowData, zoneLow: e.target.value })} disabled={!isEditZone} /> : row.zoneLow}</td>
                  </>
                )}
                <td>{editIndex === index ? <input type="checkbox" checked={editRowData.strictFlag} onChange={(e) => setEditRowData({ ...editRowData, strictFlag: e.target.checked })} /> : (row.strictFlag ? 'Y' : 'N')}</td>
                <td>
                  {editIndex === index
                    ?  <select
                          value={editRowData.srStrictType}
                          onChange={e => setEditRowData({ ...editRowData, srStrictType: e.target.value })}
                        >
                        <option value="">Select Type</option>
                        <option value="ALL">ALL</option>
                        <option value="BOTH_BUY_AND_SELL">BOTH_BUY_AND_SELL</option>
                        <option value="BOTH_BUY_AND_SELL_WITH_CLOSE">BOTH_BUY_AND_SELL_WITH_CLOSE</option>
                        <option value="BUY_ONLY">BUY_ONLY</option>
                        <option value="BUY_ONLY_WITH_CLOSE">BUY_ONLY_WITH_CLOSE</option>
                        <option value="SELL_ONLY">SELL_ONLY</option>
                        <option value="SELL_ONLY_WITH_CLOSE">SELL_ONLY_WITH_CLOSE</option>
                        <option value="CLOSE_ONLY">CLOSE_ONLY</option>
                        <option value="CLOSE_BUY_ONLY">CLOSE_BUY_ONLY</option>
                        <option value="CLOSE_SELL_ONLY">CLOSE_SELL_ONLY</option>
                        </select>
                    : row.srStrictType
                  }
                </td>

                <td>
                  {editIndex === index
                    ?  <select
                          value={editRowData.crossModeForEntry}
                          onChange={e => setEditRowData({ ...editRowData, crossModeForEntry: e.target.value })}
                        >
                    <option value="">All</option>
                    <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
                    <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
                    <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
                        </select>
                    : row.crossModeForEntry
                  }
                </td>
                <td>
                  {editIndex === index
                    ?  <select
                          value={editRowData.crossModeForExit}
                          onChange={e => setEditRowData({ ...editRowData, crossModeForExit: e.target.value })}
                        >
                    <option value="">All</option>
                    <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
                    <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
                    <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
                        </select>
                    : row.crossModeForExit
                  }
                </td>                

                <td>
                  {editIndex === index
                    ? <input
                        type="text"
                        value={editRowData.comments}
                        onChange={e => setEditRowData({ ...editRowData, comments: e.target.value })}
                      />
                    : row.comments
                  }
                </td>

                <td>{editIndex === index ? <select
                    value={editRowData.timeFrame}
                    onChange={(e) => setEditRowData({ ...editRowData, timeFrame: e.target.value })}
                  >
                    <option value="">Select</option>
                    {timeFrameOptions.map((tf, index) => (
                      <option key={index} value={tf}>{tf}</option>
                    ))}
                  </select>
                  : row.timeFrame}
                  </td>
                  
                <td>{editIndex === index ? <select value={editRowData.activeFlag} onChange={(e) => setEditRowData({ ...editRowData, activeFlag: e.target.value })}><option value="Y">Y</option><option value="N">N</option></select> : row.activeFlag}</td>
                <td>{editIndex === index ? <select value={editRowData.status} onChange={(e) => setEditRowData({ ...editRowData, status: e.target.value })}>
                  <option value="TAKEN_OUT">TAKEN_OUT</option>
                  <option value="LIQ_SWEPT">LIQ_SWEPT</option>
                  <option value="FVG_TAGGED">FVG_TAGGED</option>
                  <option value="FVG_SWEPT">FVG_SWEPT</option>
                  <option value="__EMPTY__">[Empty / Null]</option>
                  </select> : row.status}</td>
                <td>
                  {editIndex === index
                    ? <input
                        type="text"
                        value={editRowData.levelTakenOutOn}
                        onChange={e => setEditRowData({ ...editRowData, levelTakenOutOn: e.target.value })}
                      />
                    : row.levelTakenOutOn
                  }
                </td>

                <td>{editIndex === index
                  ? <select value={editRowData.msbStatus || ''} onChange={e => setEditRowData({ ...editRowData, msbStatus: e.target.value })}>
                      <option value="">Select</option>
                      <option value="MSB_BULLISH">MSB_BULLISH</option>
                      <option value="MSB_BEARISH">MSB_BEARISH</option>
                    </select>
                  : row.msbStatus}</td>

                <td>{editIndex === index
                  ? <input type="text" value={editRowData.swingLevelRetestedOn || ''} onChange={e => setEditRowData({ ...editRowData, swingLevelRetestedOn: e.target.value })} />
                  : row.swingLevelRetestedOn}</td>

                <td>{editIndex === index
                  ? <input type="text" value={editRowData.swingLevelWickRetestedOn || ''} onChange={e => setEditRowData({ ...editRowData, swingLevelWickRetestedOn: e.target.value })} />
                  : row.swingLevelWickRetestedOn}</td>
              
                <td>
                  {editIndex === index
                    ? <input
                        type="number"
                         value={editRowData.wickLowOrHigh || ''}
                         onChange={e => setEditRowData({ ...editRowData, wickLowOrHigh: e.target.value.toString() })}
                      />
                    : row.wickLowOrHigh}
                </td>

                <td>
                  {editIndex === index
                  ? <select
                      value={editRowData.attemptAllowed || ''}
                      onChange={e => setEditRowData({ ...editRowData, attemptAllowed: e.target.value })}
                    >
                      <option value="">Select</option>
                      {attemptOptions.map((opt, idx) => (
                        <option key={idx} value={opt}>{opt}</option>
                      ))}
                    </select>
                    : row.attemptAllowed}
                </td>

                <td>
                  {editIndex === index
                  ? <select
                      value={editRowData.attemptCompleted || ''}
                      onChange={e => setEditRowData({ ...editRowData, attemptCompleted: e.target.value })}
                    >
                      <option value="">Select</option>
                      {attemptOptions.map((opt, idx) => (
                        <option key={idx} value={opt}>{opt}</option>
                      ))}
                    </select>
                    : row.attemptCompleted}
                </td>
        
                <td>{editIndex === index
                  ? <input type="number" value={editRowData.derivedFromZoneId || ''} onChange={e => setEditRowData({ ...editRowData, derivedFromZoneId: e.target.value })} />
                  : row.derivedFromZoneId}</td>

                <td>{editIndex === index
                  ? <input type="number" value={editRowData.breakerZoneId || ''} onChange={e => setEditRowData({ ...editRowData, breakerZoneId: e.target.value })} />
                  : row.breakerZoneId}</td>
               <td>{row.createdDate ? new Date(row.createdDate).toLocaleString() : ''}</td>
               <td>{row.modifiedDate ? new Date(row.modifiedDate).toLocaleString() : ''}</td>

                <td>
                  {editIndex === index ? (
                    <>
                      <button className="btn save" onClick={handleSave}>Save</button>
                      <button className="btn cancel" onClick={() => setEditIndex(null)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <button className="btn edit" onClick={() => handleEdit(index)}>Edit</button>
                      <button className="btn delete" onClick={() => setConfirmDelete({ show: true, id: row.id })}>Delete</button>
                    </>
                  )}
                </td>
              </tr>
            ))}
            <tr ref={newRowRef}>
               <td> </td>
              <td><select
                        ref={coinSelectRef}
                        className="new-row-select"
                        value={newRow.coin}
                        onChange={(e) => setNewRow({ ...newRow, coin: e.target.value })}
                      >
                        <option value="">Select Coin</option>
                        {coinDropdownOptions.map((coin, index) => (
                          <option key={index} value={coin}>{coin}</option>
                        ))}
                      </select>
              </td>
              <td><select value={newRow.type} onChange={(e) => setNewRow({ ...newRow, type: e.target.value })}>
                  <option value="">Select</option>
                    {TYPE_OPTIONS.map(t => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                </select></td>
              {showSRColumn && (
              <td>                
                <input
                    value={newRow.srLevel}
                    onChange={e => setNewRow({ ...newRow, srLevel: e.target.value })}
                  disabled={newRow.type ? !SR_TYPES.includes(newRow.type) : false}
                    placeholder="SR Level"
                  />

                {newRow.type === 'SR' && <span className="auto-level-icon" onClick={openAutoLevelModal}>⚙️</span>}
              </td>
              )}
              {showZoneColumns && (
                <>
                  <td>
                    <input
                      value={newRow.zoneHigh}
                      onChange={e => setNewRow({ ...newRow, zoneHigh: e.target.value })}
                    disabled={newRow.type ? !ZONE_TYPES.includes(newRow.type) : false}
                      placeholder="Zone High"
                    />
                  </td>

                  <td>
                    <input
                      value={newRow.zoneLow}
                      onChange={e => setNewRow({ ...newRow, zoneLow: e.target.value })}
                    disabled={newRow.type ? !ZONE_TYPES.includes(newRow.type) : false}
                      placeholder="Zone Low"
                    />
                  </td>
                </>
              )}
              <td><input type="checkbox" checked={newRow.strictFlag} onChange={(e) => setNewRow({ ...newRow, strictFlag: e.target.checked })} /></td>
              <td>
               <select
                  value={newRow.srStrictType}
                  onChange={e => setNewRow({ ...newRow, srStrictType: e.target.value })}
                >
                  <option value="">Select</option>
                  <option value="ALL">ALL</option>
                  <option value="BOTH_BUY_AND_SELL">BOTH_BUY_AND_SELL</option>
                  <option value="BOTH_BUY_AND_SELL_WITH_CLOSE">BOTH_BUY_AND_SELL_WITH_CLOSE</option>
                  <option value="BUY_ONLY">BUY_ONLY</option>
                  <option value="BUY_ONLY_WITH_CLOSE">BUY_ONLY_WITH_CLOSE</option>
                  <option value="SELL_ONLY">SELL_ONLY</option>
                  <option value="SELL_ONLY_WITH_CLOSE">SELL_ONLY_WITH_CLOSE</option>
                  <option value="CLOSE_ONLY">CLOSE_ONLY</option>
                  <option value="CLOSE_BUY_ONLY">CLOSE_BUY_ONLY</option>
                  <option value="CLOSE_SELL_ONLY">CLOSE_SELL_ONLY</option>
                </select>
              </td>
              <td>
               <select
                  value={newRow.crossModeForEntry}
                  onChange={e => setNewRow({ ...newRow, crossModeForEntry: e.target.value })}
                >
                    <option value="">All</option>
                    <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
                    <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
                    <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
                </select>
              </td>
              <td>
               <select
                  value={newRow.crossModeForExit}
                  onChange={e => setNewRow({ ...newRow, crossModeForExit: e.target.value })}
                >
                    <option value="">All</option>
                    <option value="FIRST_CANDLE_CROSS">FIRST_CANDLE_CROSS</option>
                    <option value="CONFIRMED_CROSS">CONFIRMED_CROSS</option>
                    <option value="DOUBLE_CONFIRMED_CROSS">DOUBLE_CONFIRMED_CROSS</option>
                </select>
              </td>              

              <td>
                <input
                  type="text"
                  placeholder="Comments"
                  value={newRow.comments}
                  onChange={e => setNewRow({ ...newRow, comments: e.target.value })}
                />
              </td>
              <td>
                <select
                  className="new-row-select"
                  value={newRow.timeFrame}
                  onChange={(e) => setNewRow({ ...newRow, timeFrame: e.target.value })}
                >
                  <option value="">Select</option>
                  {timeFrameOptions.map((tf, index) => (
                    <option key={index} value={tf}>{tf}</option>
                  ))}
                </select>
              </td>

              <td><select value={newRow.activeFlag} onChange={(e) => setNewRow({ ...newRow, activeFlag: e.target.value })}><option value="Y">Y</option><option value="N">N</option></select></td>
             <td><select value={newRow.status} onChange={(e) => setNewRow({ ...newRow, status: e.target.value })}>
              <option value="TAKEN_OUT">TAKEN_OUT</option>
              <option value="LIQ_SWEPT">LIQ_SWEPT</option>
              <option value="FVG_TAGGED">FVG_TAGGED</option>
              <option value="FVG_SWEPT">FVG_SWEPT</option>
              <option value="__EMPTY__">[Empty / Null]</option>
              </select></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td>
                <input
                  type="number"
                  step="0.0001"
                value={newRow.wickLowOrHigh}
                onChange={e => setNewRow({ ...newRow, wickLowOrHigh: e.target.value.toString() })}
                />

              </td>
              <td>
              <select
                className="new-row-select"
                value={newRow.attemptAllowed}
                onChange={e => setNewRow({ ...newRow, attemptAllowed: e.target.value })}
              >
                <option value="">Select</option>
                {attemptOptions.map((opt, idx) => (
                  <option key={idx} value={opt}>{opt}</option>
                ))}
              </select>
              </td>

              <td>
              <select
                className="new-row-select"
                value={newRow.attemptCompleted}
                onChange={e => setNewRow({ ...newRow, attemptCompleted: e.target.value })}
              >
                <option value="">Select</option>
                {attemptOptions.map((opt, idx) => (
                  <option key={idx} value={opt}>{opt}</option>
                ))}
              </select>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><button className="btn add" onClick={handleAdd}>Add</button></td>
            </tr>
          </tbody>
        </table>
        <datalist id="coinList">
          {uniqueCoins.map((coin, i) => <option key={i} value={coin} />)}
        </datalist>
        <datalist id="tfList">
          {uniqueTimeFrames.map((tf, i) => <option key={i} value={tf} />)}
        </datalist>
      </div>

      {confirmDelete.show && (
        <div className="confirm-dialog">
          <p>Are you sure you want to delete this entry?</p>
          <button className="btn delete" onClick={() => handleDelete(confirmDelete.id)}>Yes</button>
          <button className="btn cancel" onClick={() => setConfirmDelete({ show: false, id: null })}>No</button>
        </div>
      )}

      {AutoSRLevelModal()}

    </div>
  );
}



export default ManageSrDzSzLevels;



